var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tipMessage),expression:"tipMessage"}],class:( _obj = {'badge-state': true}, _obj[_vm.row.phaseStatusBackgroud] = true, _obj )},[_vm._v("\n  "+_vm._s(_vm.phase)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }